import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
const IndexTableRowHoverDropdown = ({
  children,
  onClick
}) => /*#__PURE__*/_jsx(Dropdown, {
  buttonSize: "extra-small",
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "salesContentIndexUI.tableRowHoverButtons.actions"
  }),
  "data-selenium-test": "index-actions-dropdown",
  onOpenChange: onClick,
  children: /*#__PURE__*/_jsx(List, {
    "data-selenium-test": "index-actions-dropdown-list",
    wrapChildren: true,
    children: children
  })
});
IndexTableRowHoverDropdown.propTypes = {
  children: PropTypes.any,
  onClick: PropTypes.func
};
export default IndexTableRowHoverDropdown;